import {DomainKeys} from './state.js';
import {Repository} from '../../metrics/core.js';
import {Immutable} from 'immer';
import {IOGateway} from '../../../gateway';

export const metricsDomain = DomainKeys.Metrics;

export type MetricsDomain = Immutable<{
    restrictions: 'local',
    repoId: Immutable<IOGateway.Metrics.Identity>
    repos?: readonly Repository[]
}>
